import SideCardLink from './SideCardLink';

export default SideCardLink;
